import Vue from 'vue';

export default {
  state: {
    dateRange: {
      startDate: Vue.moment().startOf('month').format('YYYY-MM-DD hh:mm'),
      endDate: Vue.moment().endOf('month').format('YYYY-MM-DD hh:mm')
    },
    hasDateRange: false,
    entity: {}
  },
  mutations: {
    SET_DATE_RANGE(state, dateRange) {
      state.dateRange = dateRange;
    },
    SET_HAS_DATE_RANGE(state, dateRange) {
      state.hasDateRange = dateRange;
    },
    SET_ENTITY(state, entity) {
      state.entity = entity;
    }
  },
  actions: {}
};
